module.exports = __webpack_public_path__ + "static/media/1.5c54ea12.webp";